import Types from "../../constants/Types.js";
import { Name } from "../builders/index.js";
export default Name({
  objectType: Types.deviceType,
  editOptions: {
    formSort: 'aa'
  },
  createOptions: {
    formSort: 'aa'
  }
});